import Grid from '@mui/material/Grid';
import DialogContent from '@mui/material/DialogContent';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';

import { LoaderDialogContent } from '../Loader/Loader';
import ModalFormTitle from '../Tables/TableWithModalEdit/modalFormPieces/ModalFormTitle';
import { DraggableDialog } from '../DraggablePaper/DraggablePaper';
import { DialogActionsWrapper } from '../Tables/TableWithModalEdit/modalFormPieces/ModalFormActions/ModalFormActions';
import generatePdfStyle from '../../routes/Reservations/TravelFile/TravelFileHomePage/AccountingSection/GeneratePdfs/generatePdfStyle';
import IframePayment from '.';

type Props = {
    open?: boolean;
    toggleOpen: (nextValue?: any) => void;
    title?: string;
    isLoading: boolean;
    finalizing: boolean;
    creditUrl: string;
    onIframeLoad: () => void;
    error?: string;
};

// The Pelecard card-charge dialog: a loader while the gateway session is being
// created, then the payment iframe once a URL is ready. Shared by every flow
// that charges a card inline (travel-file receipts, financial document
// generation) — the surrounding poll/verify/issue logic differs per flow, but
// this shell was byte-for-byte duplicated between them.
export default function PaymentIframeModal({
    open = true,
    toggleOpen,
    title = '',
    isLoading,
    finalizing,
    creditUrl,
    onIframeLoad,
    error
}: Props) {
    const classes = generatePdfStyle();

    return (
        <DraggableDialog open={open} onClose={toggleOpen} fullWidth>
            <ModalFormTitle variant="h3" title={title} toggleDialog={() => toggleOpen()} />
            <DialogContent>
                {isLoading || finalizing ? (
                    <Grid className={classes.minHeight530px}>
                        <LoaderDialogContent />
                    </Grid>
                ) : (
                    <Grid className={classes.minHeight530px} container direction="column">
                        <div className={'classes.paymentContainer'}>
                            {creditUrl.length ? (
                                <IframePayment creditUrl={creditUrl} onLoad={onIframeLoad} />
                            ) : (
                                <div></div>
                            )}
                        </div>
                    </Grid>
                )}
            </DialogContent>
            <DialogActionsWrapper>
                <Grid
                    className={classes.gridGap1}
                    container
                    direction="row-reverse"
                    alignItems="center"
                    justifyContent="flex-start"
                >
                    <Button variant="outlined" color="secondary" onClick={toggleOpen} disabled={!!error}>
                        Close
                    </Button>
                    {error && <Typography color="error">{error}</Typography>}
                </Grid>
            </DialogActionsWrapper>
        </DraggableDialog>
    );
}
